import React from 'react';
import { SectionSeparator } from '@styles/layout';
import { TestId } from '@components/test-ids';
import { Reason } from './reason/Reason';
import { useI18NextContext } from '@components/hooks';
import styled from '@emotion/styled';
import { Place } from '@model/iceberg/geography';
import { ThemeProps } from '@theme/base';

export interface NoResultsProps {
  hasNoResults: boolean;
  isLoading: boolean;
  name: string;
  place: Place;
  isDestination: boolean;
}

const Container = styled.div({
  justifyContent: 'center',
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'column'
});

const Heading: any = styled.h1(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h2 as any),
  margin: 0,
  fontWeight: 'normal'
}));

export const NoResults = ({ hasNoResults, isLoading, name, place, isDestination }: NoResultsProps) => {
  if (hasNoResults && !isLoading) {
    const t: any = useI18NextContext();
    return (
      <>
        <SectionSeparator />
        <Container data-testid={TestId.searchResults.noResults}>
          <Heading>{t('no-results__search--title')}</Heading>
          <Reason name={name} place={place} isDestination={isDestination} />
        </Container>
        <SectionSeparator />
      </>
    );
  }
  return null;
};
